import { useQuery } from "@tanstack/react-query";
import { REPORT_EMAILS_QUERY_KEY } from "Data/keys/QueryKeys";
import { ReportEmailsApiV2 } from "Data/ReportEmails.api.v2";

interface IUseQueryPreference {
  enabled: boolean
}

export const useQueryReportEmails = ({ enabled }: IUseQueryPreference) => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [REPORT_EMAILS_QUERY_KEY],
    staleTime: 60 * 5 * 1000, // 5 minutes
    retry: false,
    enabled: enabled,
    queryFn: async () => {
      const { data } = await ReportEmailsApiV2.getReportEmails();
      return data;
    },
  });

  return {
    data: data,
    refetch,
    isLoading,
    isFetching,
    error,
  }
};
